<template>
  <div class="content">
    <van-list v-model="loading" :finished="finished" :finished-text="finishText" @load="handleGetPostList">
      <div class="list" v-if="list.length > 0">
        <div v-for="(item, index) in list" :key="item.id" class="list_item" v-track="{ functionName: 'RTC专区-RTC专区详情-直播-直播列表' }" @click="handleGOTO(item)">
          <div v-if="item.meetingStatus === 1" class="item_one">
            <div class="img_box">
              <img v-if="item && item.zoomCoverPics" class="img" :src="item.zoomCoverPics[0].url" alt="" />
              <img v-if="item.iliveCoverLink" class="img" :src="item && item.iliveCoverLink" alt="" />
            </div>
            <div class="status status_1">进行中</div>
            <div class="msk">
              <div class="active_btn color_1 bg_color" v-track="{ functionName: 'RTC专区-RTC专区详情-直播-直播列表1' }" @click.stop="handleClick(item, index)">
                {{ `${item.reserveStatus}` == 0 && `${item.meetingType}` === '1' ? "预约" : "进入" }}
              </div>
              <div class="info">
                <div class="name">{{ item && item.meetingName }}</div>
              </div>
            </div>
          </div>
          <div v-else class="item_two">
            <div class="img_box">
              <img v-if="item && item.zoomCoverPics" class="img" :src="item.zoomCoverPics[0].url" alt="" />
              <img v-if="item.iliveCoverLink" class="img" :src="item && item.iliveCoverLink" alt="" />
              <div :class="['status',item.meetingStatus === 2 ? 'status_1' : 'status_2']">
                {{ item.meetingStatus === 2 ? "待开始" : "已结束" }}
              </div>
            </div>
            <div class="info">
              <div class="name">{{ item && item.meetingName }}</div>
              <div class="time" v-if="item && item.startTime">
                {{ $moment(parseInt(item.startTime)).format("MM-DD HH:mm") }}-{{$moment(parseInt(item.endTime)).format("MM-DD HH:mm")}}
              </div>
            </div>
            <div :class="['active_btn', item.meetingStatus === 2 ? 'color_1' : 'color_2']" v-track="{ functionName: 'RTC专区-RTC专区详情-直播-直播列表2' }" @click.stop="handleClick(item, index)">
              {{ item.meetingStatus === 2 ? `${item.reserveStatus}` == 0 && `${item.meetingType}` === '1' ? "预约" : "进入" : "结束" }}
            </div>
          </div>
        </div>
      </div>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getLive, liveGet } from '@/api/student'
import { liveMake } from '@/api/api'
// import { setSha } from '../../../utils/util'
// import { rolesClick } from '../data'
export default {
  props: {
    areaId: '',
    roles: {}
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNo: 1,
        pageSize: 10
      },
      isNone: false,
      finishText: '没有更多了',
      rolesData: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    roles (newval, old) {
      this.rolesData = newval
    }
  },
  mounted () {
    if (this.roles && Object.keys(this.roles).length > 0) {
      this.rolesData = this.roles
    }
  },
  methods: {
    handleGetPostList () {
      let params = {
        pageNum: this.pageObj.pageNo,
        pageSize: this.pageObj.pageSize,
        areaId: this.areaId,
        userId: this.userInfo.id
      }
      getLive(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    },
    async handleClick (item, idx) {
      // if (rolesClick(this.rolesData, this.userInfo)) return
      if (`${item.meetingStatus}` === '3') return
      if (`${item.reserveStatus}` === '1' || `${item.meetingType}` === '2') {
        this.handleGOTO(item)
        return
      }
      let params = {
        liveId: item.meetingLink,
        userId: this.userInfo.id,
        type: 1
      }
      const res = await liveMake(params)
      if (res && res.code === 111) {
        return
      }
      let liveparams = {
        userId: this.userInfo.id,
        iliveId: item.meetingLink
      }
      const res1 = await liveGet(liveparams)
      if (res1 && res1.code === 111) {
        return
      }
      this.$toast('预约成功')
      this.$set(this.list[idx], 'reserveStatus', '1')
    },
    handleGOTO (item) {
      if (`${item.meetingType}` === '1') {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.meetingLink}&businessId=${this.areaId}&entrance=53&channel=53`)
        this.$router.push({
          path: '/liveDetails',
          query: {
            liveId: item.meetingLink,
            businessId: this.areaId,
            entrance: 53,
            channel: 53,
          },
        })
      } else {
        window.open(item.meetingLink)
      }
    }
  }
}
</script>

<style scoped lang="less">
.content {
  min-height: calc(100vh - 260px);
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
}

.list {
  padding: 10px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg,
      #f6f8fa 0%,
      #f6f8fa 6%,
      #f6f8fa 8%,
      #f6f8fa 100%);

  &_item {
    .item_one {
      width: 344px;
      height: 182px;
      border-radius: 12px;
      position: relative;
      margin-bottom: 10px;
      overflow: hidden;

      .msk {
        width: 344px;
        height: 182px;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .img_box {
        width: 100%;
        height: 182px;
        position: relative;
        margin-right: 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        .img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
      }

      .status {
        position: absolute;
        top: 7px;
        left: 10px;
        z-index: 2;
      }

      .bg_color {
        background: #fff;
      }

      .info {
        position: absolute;
        bottom: 6px;
        left: 8px;

        .name {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
          max-width: 240px;
        }
      }
    }

    .item_two {
      width: 344px;
      min-height: 88px;
      background: #ffffff;
      border-radius: 12px;
      display: flex;
      padding: 10px 8px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 10px;

      .img_box {
        width: 103px;
        height: 68px;
        position: relative;
        margin-right: 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        .img {
          width: 103px;
          height: 68px;
        }
      }

      .info {
        .name {
          font-family: PingFang HK, PingFang HK;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          margin-bottom: 16px;
          max-width: 220px;
        }

        .time {
          font-family: PingFang HK, PingFang HK;
          font-weight: 400;
          font-size: 12px;
          color: #b1b1b1;
        }
      }

      .active_btn_1 {
        width: 56px;
        height: 23px;
        background: #f6f8f5;
        border-radius: 24px 24px 24px 24px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 14px;
        color: #EB1700;
        text-align: center;
        line-height: 23px;
        z-index: 2;
      }
    }
  }
}

.status_1 {
  width: 43px;
  height: 17px;
  background: #EB1700;
  box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
  border-radius: 30px;
  text-align: center;
  line-height: 17px;
  font-family: Be Vietnam Pro, Be Vietnam Pro;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}

.status_2 {
  width: 43px;
  height: 17px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 30px;
  text-align: center;
  line-height: 17px;
  font-family: Be Vietnam Pro, Be Vietnam Pro;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}

.active_btn {
  width: 56px;
  height: 23px;
  background: #f6f8f5;
  border-radius: 24px 24px 24px 24px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  line-height: 23px;
  position: absolute;
  bottom: 21px;
  z-index: 2;
  right: 11px;
}

.color_1 {
  color: #EB1700;
}

.color_2 {
  color: rgba(0, 0, 0, 0.41);
}

.status {
  position: absolute;
  top: 0;
  left: 0;
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/liveList.vue